export default __webpack_public_path__ + "static/media/IMG_0455 copie.d2290c1f.jpg";